module.exports = __webpack_public_path__ + "static/img/qrcode.cc9cbf52.png";